import { createContext, useCallback, useContext, useState } from "react";
import EmailIntakeDialog from "../components/EmailIntakeDialog";

// Global "Import Job from Email" dialog controller (Feb 2026 refit).
//
// The dialog now lives at the app-shell level rather than inside the
// Topbar. Anywhere in the tree can call `useIntakeDialog().open()` to
// summon it — currently used by the Sidebar's "Email Intake" nav item
// (was a route to /intake-inbox before the review-queue was nuked).
//
// The manual paste + parse flow is the only entry point that survived
// the intake cleanup. Auto-ingested emails from allowlisted senders
// bypass this dialog entirely and land straight in the jobs queue.

const IntakeDialogCtx = createContext({ open: () => {} });

export function useIntakeDialog() {
  return useContext(IntakeDialogCtx);
}

export function IntakeDialogProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openDialog = useCallback(() => setOpen(true), []);
  return (
    <IntakeDialogCtx.Provider value={{ open: openDialog }}>
      {children}
      <EmailIntakeDialog
        open={open}
        onOpenChange={setOpen}
        onAccepted={() => window.dispatchEvent(new CustomEvent("jobs:refresh"))}
      />
    </IntakeDialogCtx.Provider>
  );
}
